import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";

import { RegistrationPage } from "./pages/RegistrationPage";
import { registrationRoutes } from "./routes";

export const registrationRoute = [
  {
    path: registrationRoutes.main,
    element: <RegistrationPage />,
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
